module.exports = __webpack_public_path__ + "static/media/bg10.7db6756a.jpg";